<template>
    <div
        :class="[$style['mds-search-field'], sizeClass, variationClass, onDarkClass]"
        role="search"
        :data-mds-version="version"
    >
        <input
            type="text"
            :class="[$style['mds-search-field__input'], hasValue]"
            :value="value"
            :disabled="disabled"
            :aria-label="label"
            :placeholder="placeholder"
            v-on="inputListeners"
            ref="input"
        />
        <mds-icon name="search" :size="iconSize" :class="$style['mds-search-field__search-icon']"></mds-icon>
        <mds-button
            :class="[$style['mds-search-field__clear-button']]"
            type="button"
            variation="icon-only"
            :size="iconSize"
            icon="remove"
            :onDark="onDark"
            :text="clearIconAriaLabel"
            @click="clearSearchField($event)"
            :disabled="disabled"
            v-show="value.length > 0"
        ></mds-button>
        <span :class="$style['mds-search-field__input-focus-outline']"></span>
    </div>
</template>

<script>
    import { MdsButton } from '@mds/button';
    import MdsIcon from '@mds/icon';
    import MdsSearchFieldProps from './search-field_props.js';

    export default {
        name: 'MdsSearchField',
        props: MdsSearchFieldProps,
        components: {
            MdsButton,
            MdsIcon,
        },
        model: {
            prop: 'value',
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-search-field--${this.size}`];
            },
            variationClass() {
                return this.$style[`mds-search-field--${this.variation}`];
            },
            onDarkClass() {
                return this.onDark ? this.$style['mds-component--on-dark'] : null;
            },
            hasValue() {
                return this.value && this.value.length > 0 ? this.$style['mds-search-field__input--has-value'] : null;
            },
            iconSize() {
                return this.size === 'small' || this.size === 'medium' ? 'small' : 'medium';
            },
            inputListeners() {
                var vm = this;
                return Object.assign({}, this.$listeners, {
                    input(event) {
                        vm.$emit('input', event.target.value, event);
                    },
                });
            },
        },
        methods: {
            clearSearchField(event) {
                const input = this.$refs.input;
                input.value = '';
                this.$emit('input', '', event);

                // Custom event if teams wish to listen
                this.$emit('mds-search-field-input-cleared', event);

                // After clearing, bring focus back into the search field
                input.focus();
            },
        },
    };
</script>

<style lang="scss" module>
    @import './search-field.scss';
</style>
